import React from "react";
import CustomDogIcon, {DogColors, DogIcon} from "../customDogIcon/CustomDogIcon";
import "./_error.scss"
import {useQueryParam} from "../utilities/UseQueryParams";

export const GetErrorTemplate = (company, application) => {
    let reason = useQueryParam("Reason");
    let errorCode = useQueryParam("ErrorCode");
    return (
        <div className={"error-container"}>
            <div className={"error-container__title"}>
                <span>{company.name} Sign-In To {application.name} Unsuccessful</span></div>

            <CustomDogIcon className={"error-container__error-dog"} dogColor={DogColors.danger}
                           IconType={DogIcon.ErrorDog}/>
            <div className={"error-container__message"}>
                <div className={"error-container__message__status"}>Unable to sign you in to {application.name}</div>
                <br/>
                <div className={"error-container__message__contact"}>
                    <div>E-mail: <a href={"mailto:support@afti.ca"}>support@afti.ca</a></div>
                    <div>Tel: (403) 212-2382</div>
                </div>
                <div>Please contact AFTI customer service and provide the error information below.</div>
                <div className={"error-container__message__error-code"}>{reason && reason + " - " + errorCode}</div>
            </div>
        </div>
    )
}
